import moment from "moment";
import { currencyFormat } from "./epaycoCheckout";
import { find, map, uniq } from "lodash";
import { language } from "./language";
import { isFreeShippingCoupon } from "./discountTypes";

export const formatPhoneNumber = (str: string, flags: string) => {
  //Filter only numbers from the input
  let cleaned = ("" + str).replace(/\D/g, "");

  //Check if the input is of correct
  let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  let intlCode = flags + " ";
  if (match) {
    //Remove the matched extension code
    //Change this to format for any country code.
    return [intlCode, "", match[2], " ", match[3], " ", match[4]].join("");
  } else {
    return intlCode + str;
  }

  return "";
};

export const calculatePriceWithTax = (product: ProductType) => {
  if (product.discountRate > 0) {
    let amountRate = 100 - product.discountRate;
    return (product.amount * 100) / amountRate;
  }
  return product.amount;
};

export const formatNameCity = (name: string) => {
  if (name !== "BOGOTÁ D.C.") {
    let name2 = name;
    if (name.charCodeAt(0) === 160) {
      name2 = name.slice(1);
    }
    const arr = name2.split(" ");
    for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLowerCase();
    }
    const str2 = arr.join(" ");
    return str2;
  } else {
    return "Bogotá D.C.";
  }
};

export const formatErrorQuote = (message: string, defaultLanguage: string) => {
  switch (message) {
    case "El valor maximo para el paramentro largo es 80cm":
      return language[defaultLanguage]["messageElogisticaError"];
    case "El valor maximo para el paramentro ancho es 80cm":
      return language[defaultLanguage]["messageElogisticaError"];
    case "El valor maximo para el paramentro alto es 80cm":
      return language[defaultLanguage]["messageElogisticaError"];
    case "El peso total del envio supera los 10 kg, revise el array de productos":
      return language[defaultLanguage]["messageElogisticaError"];
    case "El valor maximo para el paramentro peso_real es 10 kg":
      return language[defaultLanguage]["messageElogisticaError"];
    case "La ciudad de destino u origen seleccionada no esta disponible para el servicio":
      return language[defaultLanguage]["messageElogisticaError2"];
    case "No hay servicios disponibles para las características del envio":
      return language[defaultLanguage]["messageElogisticaError2"];
    case "Actualmente NO se tiene habilitado el servicio para la ruta y tipo de transporte seleccionados.":
      return language[defaultLanguage]["messageElogisticaError2"];
    case "El valor mínimo para el paramentro ancho es 1":
      return language[defaultLanguage]["messageElogisticaError3"];
    case "El valor mínimo para el paramentro alto es 1":
      return language[defaultLanguage]["messageElogisticaError3"];
    case "El valor mínimo para el paramentro largo es 1":
      return language[defaultLanguage]["messageElogisticaError3"];
    case "El valor mínimo para el paramentro peso_real es 1":
      return language[defaultLanguage]["messageElogisticaError3"];
    default:
      return language[defaultLanguage]["messageElogisticaError4"];
  }
};

export const formatDate = (date: Date) => {
  let day = date.getDate().toString();
  let month = (date.getMonth() + 1).toString();
  let year = date.getFullYear().toString();
  return `${day.length === 1 ? "0" : ""}${day}/${
    month.length === 1 ? "0" : ""
  }${month}/${year}`;
};

export const returnProduct = (
  product: any,
  type = "",
  nameRefSelect: any = null
) => {
  if (product.references && product.references.length > 0) {
    let itemRef;
    if (nameRefSelect === null || nameRefSelect === undefined) {
      let itemRefDefault = product.references.find(
        (item: any) =>
          (type !== "" && item[type] > 0) || (type === "" && item.amount > 0)
      );
      itemRefDefault = itemRefDefault ? itemRefDefault : product.references[0];
      itemRef = product.references.reduce((prev: any, curr: any) => {
        if (
          (type !== "" && curr[type] !== 0 && curr[type] < prev[type]) ||
          (type === "" && curr.amount !== 0 && curr.amount < prev.amount)
        ) {
          itemRefDefault = curr;
        }
        return (type !== "" && prev[type] < curr[type] && prev[type] !== 0) ||
          (type === "" && prev.amount < curr.amount)
          ? prev
          : itemRefDefault;
      });
    } else {
      itemRef = product.references.find(
        (item: any) => item.name === nameRefSelect
      );
    }
    return type === "" ? itemRef : itemRef[type];
  }
  return type === "" ? product : product[type];
};

export const validateSelect = (refSelect: any, product: any) => {
  if (refSelect !== null) {
    return (
      !product.references ||
      (product.references && product.references.length === 0) ||
      (product.references &&
        refSelect.find((item: any) => item === null) === undefined)
    );
  }
  return true;
};

export const findNameRef = (refSelect: any) => {
  if (refSelect !== null && Array.isArray(refSelect)) {
    const selected = refSelect.filter((item) => item !== null);
    if (selected.length === refSelect.length) {
      let refName = refSelect[0];
      refSelect.map((item: any, key: number) => {
        if (key !== 0) {
          refName = `${refName}/${item}`;
        }
        return item;
      });
      return refName;
    }
  }
  return null;
};

export const findAmountProduct = (
  product: any,
  field: string | null = "amount"
) => {
  if (product.references && product.references.length > 0) {
    const reference = product.references[0].data;
    if (field !== null && reference) {
      return reference?.[field];
    }
    return reference;
  }
  return field !== null ? product.productData[field] : product.productData;
};

export const validateFilterShopping = (coupon: Coupon, totalAmount: number) => {
  if (coupon.type === "monto fijo") {
    const value =
      coupon.filterShopping && coupon.minCartAmount > coupon.value
        ? coupon.minCartAmount
        : coupon.value;
    return value <= totalAmount;
  }
  return !coupon.filterShopping || coupon.minCartAmount <= totalAmount;
};

const productDiscountValue = (coupon: Coupon) =>
  isFreeShippingCoupon(coupon) ? 0 : coupon.value;

export const viewDiscountTab = (
  product: any,
  coupon: Coupon,
  totalAmount: number,
  appliedCoupons: Coupon[],
  obj: boolean = false
) => {
  const categoriesId = coupon.allowedCategories.map((item: any) => item.id);
  let applyItem: any = {};
  const validInitDate = moment(coupon.validInitDate, "YYYY-MM-DD").startOf(
    "day"
  );
  const validUntil = moment(coupon.validUntil, "YYYY-MM-DD").endOf("day");
  const today = moment().startOf("day");
  applyItem.filterCategory =
    !coupon.filterCategory ||
    (categoriesId.length > 0 &&
      categoriesId.includes(parseInt(product.productData.categories[0])));
  applyItem.allowCombination =
    appliedCoupons.length === 1 || validateAllowCombination(appliedCoupons);
  applyItem.filterAmount = !coupon.filterAmount || coupon.quantity > 0;
  applyItem.filterShopping = validateFilterShopping(coupon, totalAmount);
  applyItem.filterTimeframe =
    !coupon.filterTimeframe ||
    (validInitDate.isSameOrBefore(today) && validUntil.isAfter(today));
  return !obj
    ? applyItem.filterCategory &&
        applyItem.allowCombination &&
        applyItem.filterAmount &&
        applyItem.filterShopping &&
        applyItem.filterTimeframe
    : applyItem;
};

export const viewDiscountAmount = (
  product: any,
  appliedCoupons: Coupon[],
  totalAmount: number,
  field: string = "amount"
) => {
  if (appliedCoupons.length === 0) return field === "amount" ? 0 : false;
  else {
    let amount = 0;
    let apply = false;
    for (let i = 0; i < appliedCoupons.length; i++) {
      const coupon = appliedCoupons[i];
      if (viewDiscountTab(product, coupon, totalAmount, appliedCoupons)) {
        apply = true;
        if (coupon.type !== "monto fijo") {
          let quantity = 1;
          if (product.references && product.references.length > 0) {
            quantity = product.references[0].quantity;
          } else {
            quantity = product.quantity;
          }
          amount +=
            ((findAmountProduct(product) * productDiscountValue(coupon)) / 100) *
            quantity;
        }
      }
    }
    return field === "amount" ? amount : apply;
  }
};

export const viewTotalDiscountAmount = (
  products: any[],
  appliedCoupons: Coupon[],
  totalAmount: number,
  field: string = "amount",
  currency: string = "COP",
  defaultLanguage: string
) => {
  let result: any = {
    amount: 0,
    totalTax: 0,
    amountTax: 0,
    amountConsumptionTax: 0,
    apply: false,
    errors: [],
    countErrorCategories: 0,
  };

  for (let i = 0; i < appliedCoupons.length; i++) {
    const coupon = appliedCoupons[i];
    let appliedAmount = 0;
    for (let i2 = 0; i2 < products.length; i2++) {
      const applyItem = viewDiscountTab(
        products[i2],
        coupon,
        totalAmount,
        appliedCoupons,
        true
      );
      if (
        applyItem.filterCategory &&
        applyItem.allowCombination &&
        applyItem.filterAmount &&
        applyItem.filterShopping &&
        applyItem.filterTimeframe
      ) {
        result.apply = true;
        let quantity = 1;
        if (products[i2].references && products[i2].references.length > 0) {
          quantity = products[i2].references[0].quantity;
        } else {
          quantity = products[i2].quantity;
        }
        /* El codigo de descuento se debe aplicar tanto al costo del producto y de la misma forma al impuesto del producto*/
        if (coupon.type !== "monto fijo") {
          const discountValue = productDiscountValue(coupon);
          let discountCodeAmount =
            ((findAmountProduct(products[i2]) * discountValue) / 100) * quantity;
          let taxAmount = calculateTaxPercentage(
            products[i2],
            discountValue,
            quantity
          );
          result.amount += discountCodeAmount;
          result.totalTax += taxAmount.totalTaxAfterDiscount;
          result.amountTax += taxAmount.amountTax;
          result.amountConsumptionTax += taxAmount.amountConsumptionTax;
        } else {
          let subsAmount: any = discountAppliedAmountFixed(
            findAmountProduct(products[i2]) * quantity,
            coupon.value,
            appliedAmount
          );
          let taxAmount = calculateTaxPercentage(
            products[i2],
            subsAmount.percentage,
            quantity
          );
          let discountCodeAmount = subsAmount.discountCodeAmount;
          appliedAmount += discountCodeAmount;
          result.totalTax += taxAmount.totalTaxAfterDiscount;
          result.amountTax += taxAmount.amountTax;
          result.amountConsumptionTax += taxAmount.amountConsumptionTax;
          result.amount += discountCodeAmount;
        }
      } else {
        if (!applyItem.filterCategory) {
          result.countErrorCategories++;
        }
        if (!applyItem.allowCombination)
          result.errors.push(`*${language[defaultLanguage]["errorCode"]}.`);
        if (!applyItem.filterAmount)
          result.errors.push(`*${language[defaultLanguage]["errorCode2"]}.`);
        if (!applyItem.filterShopping) {
          const value =
            coupon.filterShopping && coupon.minCartAmount > coupon.value
              ? coupon.minCartAmount
              : coupon.value;
          const errorMessage = language[defaultLanguage]["errorCode5"].replace(
            "{amount}",
            currencyFormat(value, currency)
          );
          result.errors.push(`*${errorMessage}`);
        }
        if (!applyItem.filterTimeframe)
          result.errors.push(`*${language[defaultLanguage]["errorCode2"]}.`);

        //calculo de impuestos
        let quantity = 1;
        if (products[i2].references && products[i2].references.length > 0) {
          quantity = products[i2].references[0].quantity;
        } else {
          quantity = products[i2].quantity;
        }
        let discountPrice =
          findAmountProduct(products[i2], "discountPrice") * quantity;
        let amount = findAmountProduct(products[i2]) * quantity;
        //total del precio con impuestos - total de precio sin impuestos = total del impuesto del producto
        let taxAmount = amount - discountPrice;
        result.totalTax += taxAmount;
      }
    }
    if (result.countErrorCategories === products.length) {
      const categoriesName = coupon.allowedCategories.map(
        (item: any) => item.name
      );
      const term =
        categoriesName.length > 1
          ? language[defaultLanguage]["categories"]
          : language[defaultLanguage]["category2"];
      result.errors.push(
        `*${
          language[defaultLanguage]["errorCode6"]
        } ${term} ${categoriesName.join(", ")}.`
      );
    }
    result.countErrorCategories = 0;
  }
  if (appliedCoupons.length > 0 && appliedCoupons[0].type !== "monto fijo") {
    let percentageDiscount = (result.amount * 100) / totalAmount;
    if (percentageDiscount > 90) {
      result.errors.push(`*${language[defaultLanguage]["errorCode9"]}`);
    }
  }

  result.amount = result.amount > totalAmount ? totalAmount : result.amount;
  return field !== "" ? result[field] : result;
};

export const totalQuantityPrice = (product: any) => {
  if (product.references && product.references.length > 0) {
    return product.references[0].data.amount * product.references[0].quantity;
  } else {
    return product.productData.amount * product.quantity;
  }
};

const discountAppliedAmountFixed = (
  amountProduct: number,
  valueDiscount: number,
  appliedAmount: number
) => {
  if (appliedAmount < valueDiscount) {
    let remaining = valueDiscount - appliedAmount;
    if (remaining >= amountProduct) {
      return {
        discountCodeAmount: amountProduct,
        amountAfterDiscountCode: 0,
        percentage: 100,
      };
    }
    // se calcula el porcentaje equivalente del descuento para posteriormente calcular cuanto queda en los impuestos
    let percentage = (remaining * 100) / amountProduct;
    return {
      discountCodeAmount: remaining,
      amountAfterDiscountCode: amountProduct - remaining,
      percentage,
    };
  }
  return {
    discountCodeAmount: 0,
    amountAfterDiscountCode: amountProduct,
    percentage: 0,
  };
};

// retorna el impuesto sobrante despues de descuento y el total descuento sobre el impuesto
const calculateTaxPercentage = (
  product: any,
  valueCoupon: number,
  quantity: number
) => {
  // el calculo se hace identificando aplicando el % de descuento a los impuestos por separado y luego se agrupan
  let amountConsumptionTaxBefore =
    findAmountProduct(product, "consumptionTaxAmount") * quantity;
  let amountTaxBefore = findAmountProduct(product, "taxAmount") * quantity;
  let totalTaxBeforeDiscount = amountTaxBefore + amountConsumptionTaxBefore;
  let amountTax = (amountTaxBefore * valueCoupon) / 100;
  let amountConsumptionTax = (amountConsumptionTaxBefore * valueCoupon) / 100;
  //totalTaxBeforeDiscount = total de impuestos antes del descuento
  //totalTaxAfterDiscount = total de impuestos despues del descuento
  //discountAppliedTax = descuento aplicado sobre el impuesto
  let discountAppliedTax = amountTax + amountConsumptionTax;
  return {
    totalTaxAfterDiscount: totalTaxBeforeDiscount - discountAppliedTax,
    discountAppliedTax: discountAppliedTax,
    amountTax,
    amountConsumptionTax,
  };
};

const validateAllowCombination = (appliedCoupons: Coupon[]) => {
  let disableCombine =
    find(appliedCoupons, (item: Coupon) => item.allowCombination === 0) !==
    undefined;
  let uniqType = uniq(map(appliedCoupons, "type")).length === 1;
  return !disableCombine && uniqType;
};

export const adjustmentAmounts = (
  totalPay: number,
  baseTax: number,
  taxAmount: number,
  consumptionTaxAmount: number,
  shippingCost: number,
): any => {
  const preTotal = baseTax + taxAmount + consumptionTaxAmount + shippingCost;
  const difference = totalPay - preTotal;
  
  // Si no hay diferencia, devolver los valores originales
  if (Math.abs(difference) < 0.001) {
    return {
      totalPay,
      baseTax,
      taxAmount,
      consumptionTaxAmount,
    };
  }

  // Ajustar el baseTax para que la suma total sea exactamente igual a totalPay
  const adjustedBaseTax = parseFloat((baseTax + difference).toFixed(3));

  return {
    totalPay,
    baseTax: adjustedBaseTax,
    taxAmount,
    consumptionTaxAmount,
  };
};
